module.exports = require('./dist/lib/accessible-autocomplete.react.min')



/** WEBPACK FOOTER **
 ** ./~/accessible-autocomplete/react.js
 **/